module.exports = __webpack_public_path__ + "img/i2.837ba300.png";